import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerProfileComponent } from './broker-profile.component';
import { BrokerHeaderModule } from '../broker-header/broker-header.module';
import { SearchOrderModule } from '../components/search-order/search-order.module';
import { CardGridModule } from '../components/card-grid/card-grid.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SearchFilterWrapperModule } from '../components/search-filter-wrapper/search-filter-wrapper.module';
import { CommonsLibModule } from 'commons-lib';
import { BrokerModalEditionModule } from '../broker-modal-edition/broker-modal-edition.module';

@NgModule({
  imports: [
    CommonModule,
    BrokerHeaderModule,
    SearchOrderModule,
    SearchFilterWrapperModule,
    CardGridModule,
    NgZorroAntdModule,
    CommonsLibModule,
    BrokerModalEditionModule
  ],
  declarations: [BrokerProfileComponent]
})
export class BrokerProfileModule {}
